import "./BlogInnerAccor.css";
import { useEffect, useRef } from "react";
function BlogInnerAccor({ blog }) {
  const contentRef = useRef();

  useEffect(() => {
    if (!contentRef.current) return;

    const headings = contentRef.current.querySelectorAll("p");

    headings.forEach((heading, index) => {
      heading.setAttribute("id", `section-${index}`);
    });
  }, [blog]);
  if (!blog) return null; // ✅ prevents crash

  return (
    <>
      <h6 className="heading"> {blog.title ? blog.title.toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ") : "Recent Posts"}</h6>
      <p className="text"> {blog.desc ? blog.desc : "Description"}</p>
      {/* ✅ ADD THIS */}
      {/* {blog.banner && (
        <img className="durationBoxDiv-img"
          src={blog.banner}
          alt={blog.title}
          style={{ width: "100%", margin: "20px 0", borderRadius: "10px" }}
        />
      )} */}
      <div
        className="durationBoxDiv"
        dangerouslySetInnerHTML={{ __html: blog.content || "" }}
      />
    </>);
}

export default BlogInnerAccor;